export default __webpack_public_path__ + "static/media/m-fsk-14.d23581c6.jpg";